import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { InstantBankTransferService } from '../instant-bank-transfer.service';
import { TransactionService } from '../transaction/transaction.service';
import { Action, Amount, ConfirmOrchestrationResponse, Currency, FlowCode, OrchestrationRequest, OrchestrationResponse, PartnerValidationErrorResponse } from '../general.model';
import { AuthService } from '../transaction/auth.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-receive-money-abroad-confirm',
  standalone: true,
  imports: [MessageModule,CommonModule,ButtonModule],
  templateUrl: './receive-money-abroad-confirm.component.html',
  styleUrl: './receive-money-abroad-confirm.component.css'
})
export class ReceiveMoneyAbroadConfirmComponent implements OnInit, OnDestroy {

  data ={
    bankLocation: '',
    purpose: '',
    currency: '',
    sourceCurrency:"",
    targetCurrency:"",
    rate: 0,
    amount: 0,
    converted: 0,
    time: 'Up to 24 hours',
    cost: 530
  }; 
  
  /*{
    bankLocation: 'United Kingdom',
    purpose: 'Family support',
    currency: 'GBP',
    sourceCurrency:"",
    targetCurrency:"",
    rate: 6.49,
    amount: 500,
    converted: 3245,
    time: 'Up to 24 hours',
    cost: 530
  };*/
  
  
  private timerId: ReturnType<typeof setTimeout> | null = null;
  showAlert = false;

  constructor(private router: Router,
    protected instantBankTransferService:InstantBankTransferService,
    private transactionService: TransactionService,
    protected authService: AuthService
  ) {
    let data1: any = this.instantBankTransferService.data(); 
    this.data = data1;
  }

  ngOnInit(): void {
    this.timerId = setTimeout(() => {
          //console.log('Showing alert after 5 seconds');
          this.showAlert = true;
        }, 5000);
    
  }

  ngOnDestroy(): void {    
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }

  goRefresh() {
    this.showAlert=!this.showAlert;
    this.timerId = setTimeout(() => {
      console.log('Showing alert after 5 seconds');
      this.showAlert = true;
    }, 5000);

  }

  goConfirm() {
    console.log('Confirm transfer');
    const quoteData = this.authService.quoteDetails()?.data;
    const sourceCurrency = (quoteData?.sourceCurrency ?? Currency.EUR) as Currency;
    const referenceCurrency = (sourceCurrency === Currency.EUR || sourceCurrency === Currency.GBP) ? 0 : 1;
    let amount:Amount = {currency:sourceCurrency,
      value:quoteData?.sourceAmount as number};
    let orchestrationRequest:OrchestrationRequest={
        amount: amount,
        action: Action.CONFIRM,
        flowCode: FlowCode.DW_BANK_TOPUP_THUNES,
        quoteId: quoteData?.quotationId ?? '',
        purposeOfFunds: this.instantBankTransferService.data()?.purpose,
        countryOfResidence: this.instantBankTransferService.data()?.bankLocation || '',
        referenceCurrency
    };

    const correlationId: string = this.authService.uuid() ?? '';
    this.transactionService.initiateOrchestrator(correlationId,environment.partnerId,orchestrationRequest).subscribe({
      next: (response) => {
      let confirmOrchestrationResponse: ConfirmOrchestrationResponse = response;
      this.authService.setConfirmTransactionResponse(confirmOrchestrationResponse);
      this.router.navigate(['/authorize']);
      console.log('Data received:', response);
    },
      error: (err) => {
        let partnerValidationErrorResponse:PartnerValidationErrorResponse=err;
        if(partnerValidationErrorResponse.error.code==="BANK_DEBIT_INITIATION_FAILED"){
          this.router.navigate(['/service-unavailable']);
        }else if(partnerValidationErrorResponse.error.code==="LIMIT_REACHED"){
          this.router.navigate(['/limit']);
        }else if(partnerValidationErrorResponse.error.code==="THUNES_DEBIT_FAILED"){
          this.router.navigate(['/insufficient-funds']);
        }else{
          this.router.navigate(['/service-unavailable']);
        }
      console.error('Error occurred:', err);
      }
    });

  }

  goEdit() {
    console.log('Edit transfer');
    this.router.navigate(['/amount']);
  }

  closeAlert(): void {
    this.showAlert = false;
  }

  converted():number{
    return this.instantBankTransferService.data().amount * this.instantBankTransferService.data().rate;    
  }

}
